module.exports = __webpack_public_path__ + "static/media/damagePin.7c25386b.svg";